// 修改antd配置 https://ant.design/docs/react/customize-theme-cn
// 可通过面板 https://ant.design/theme-editor-cn 操作
import { ConfigProviderProps } from 'antd/lib/config-provider';
import { language } from 'utils/i18n';

export const themeConfig: ConfigProviderProps['theme'] = {
    token: {
        colorPrimary: '#ffe100',
        borderRadius: 4
    },
    components: {
        Button: {
            colorTextLightSolid: '#212529',
            borderRadiusLG: 8
        },
        Spin: {
            colorPrimary: '#ffe100'
        },
        Pagination: {
            colorPrimary: '#2c2e3b',
            colorPrimaryHover: '#2c2e3b'
        },
        Modal: {
            borderRadiusLG: 8
        }
    }
};

// https://github.com/ant-design/ant-design/blob/master/components/locale/en_US.ts
export const localeConfig: ConfigProviderProps['locale'] = {
    locale: language,
    Modal: {
        okText: __('OK'),
        cancelText: __('Cancel'),
        justOkText: __('OK')
    },
    Popconfirm: {
        okText: __('OK'),
        cancelText: __('Cancel')
    },
    Empty: {
        description: __('No data')
    },
    global: {
        placeholder: __('Please select')
    },
    Table: {
        filterTitle: __('Filter menu'),
        filterConfirm: __('OK'),
        filterReset: __('Reset'),
        filterEmptyText: __('No filters'),
        filterCheckall: __('Select all items'),
        filterSearchPlaceholder: __('Search in filters'),
        emptyText: __('No data'),
        selectAll: __('Select current page'),
        selectInvert: __('Invert current page'),
        selectNone: __('Clear all data'),
        selectionAll: __('Select all data'),
        sortTitle: __('Sort'),
        expand: __('Expand row'),
        collapse: __('Collapse row'),
        triggerDesc: __('Click to sort descending'),
        triggerAsc: __('Click to sort ascending'),
        cancelSort: __('Click to cancel sorting')
    },
    DatePicker: {
        lang: {
            locale: language,
            placeholder: __('Select date'),
            yearPlaceholder: __('Select year'),
            quarterPlaceholder: __('Select quarter'),
            monthPlaceholder: __('Select month'),
            weekPlaceholder: __('Select week'),
            rangePlaceholder: [__('Start date'), __('End date')],
            rangeYearPlaceholder: [__('Start year'), __('End year')],
            rangeQuarterPlaceholder: [__('Start quarter'), __('End quarter')],
            rangeMonthPlaceholder: [__('Start month'), __('End month')],
            rangeWeekPlaceholder: [__('Start week'), __('End week')],
            today: __('Today'),
            now: __('Now'),
            backToToday: __('Back to today'),
            ok: __('OK'),
            clear: __('Clear'),
            month: __('Month'),
            year: __('Year'),
            timeSelect: __('select time'),
            dateSelect: __('select date'),
            weekSelect: __('Choose a week'),
            monthSelect: __('Choose a month'),
            yearSelect: __('Choose a year'),
            decadeSelect: __('Choose a decade'),
            yearFormat: 'YYYY',
            dateFormat: 'M/D/YYYY',
            dayFormat: 'D',
            dateTimeFormat: 'M/D/YYYY HH:mm:ss',
            monthBeforeYear: true,
            previousMonth: __('Previous month (PageUp)'),
            nextMonth: __('Next month (PageDown)'),
            previousYear: __('Last year (Control + left)'),
            nextYear: __('Next year (Control + right)'),
            previousDecade: __('Last decade'),
            nextDecade: __('Next decade'),
            previousCentury: __('Last century'),
            nextCentury: __('Next century'),
            shortWeekDays: [__('Sun'), __('Mon'), __('Tue'), __('Wed'), __('Thu'), __('Fri'), __('Sat')],
            shortMonths: [
                __('Jan'),
                __('Feb'),
                __('Mar'),
                __('Apr'),
                __('May'),
                __('Jun'),
                __('Jul'),
                __('Aug'),
                __('Sep'),
                __('Oct'),
                __('Nov'),
                __('Dec')
            ]
        },
        timePickerLocale: {
            placeholder: __('Select time'),
            rangePlaceholder: [__('Start time'), __('End time')]
        }
    }
};
